import { render, staticRenderFns } from "./educatorCanProjects.vue?vue&type=template&id=1ef587ae"
import script from "./educatorCanProjects.vue?vue&type=script&lang=js"
export * from "./educatorCanProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports